/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';

export interface ISubdivisionContext {
  parentId: number | undefined;
  setParentId: (value: number | undefined) => void;
  openSubdivisionCreateCard: boolean;
  setOpenSubdivisionCreateCard: (value: boolean) => void;
}

export const SubdivisionContext = createContext<ISubdivisionContext>({
  parentId: undefined,
  setParentId: () => {},
  openSubdivisionCreateCard: false,
  setOpenSubdivisionCreateCard: () => {},
});
